<template>
  <div class="overflow-auto bg-n-surface-1 w-full px-6">
    <!-- Sem `max-w-5xl mx-auto`: o teto de 1024px vinha do upstream e deixava
         faixa vazia dos dois lados em qualquer monitor acima disso, enquanto as
         telas do CRM ocupam a largura inteira. Duas seções de relatório com
         larguras diferentes no mesmo produto confunde mais do que a leitura
         longa incomoda, e os gráficos daqui ganham em espaço. -->
    <div class="w-full pb-12">
      <router-view />
    </div>
  </div>
</template>
